import { getBackendUrl } from '../../lib/backendUrl'

export const UNAUTHORIZED_EVENT = 'app:unauthorized'

let unauthorizedFired = false

function fireUnauthorized() {
  if (typeof window === 'undefined') return
  if (unauthorizedFired) return

  unauthorizedFired = true
  window.dispatchEvent(new Event(UNAUTHORIZED_EVENT))
  setTimeout(() => {
    unauthorizedFired = false
  }, 2_000)
}

export async function authFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const response = await fetch(input, {
    ...init,
    credentials: init?.credentials ?? 'include',
  })
  if (response.status === 401) {
    fireUnauthorized()
  }
  return response
}

export async function throwApiError(response: Response, fallback: string): Promise<never> {
  let detail = response.statusText
  try {
    const err = (await response.json()) as {
      detail?: string
      title?: string
      message?: string
      error?: string
    }
    detail = err.message || err.detail || err.title || err.error || detail
  } catch {
    // ignore non-JSON error bodies
  }

  throw new Error(`${fallback}: ${detail}`)
}

function asRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' ? (value as Record<string, unknown>) : null
}

export function unwrapObject<T>(json: unknown, keys: string[]): T {
  const record = asRecord(json)
  if (record) {
    for (const key of keys) {
      const candidate = asRecord(record[key])
      if (candidate) return candidate as T
    }
  }
  return json as T
}

export function unwrapArray<T>(json: unknown, keys: string[]): T[] {
  if (Array.isArray(json)) return json as T[]

  const record = asRecord(json)
  if (record) {
    for (const key of keys) {
      const candidate = record[key]
      if (Array.isArray(candidate)) return candidate as T[]
    }
  }

  return []
}

export function buildAgentUrl(path: string): string {
  return `${getBackendUrl()}/api/agent${path}`
}

export function buildWorkspaceUrl(path: string): string {
  return `${getBackendUrl()}${path}`
}
